import { useEffect } from 'react';

import { useFormikContext } from 'formik';

import { GaAction, GaCategory, fireGAEvent } from 'common/lib/analytics';

/**
 * Component will trigger a GA event when the parent form triggers a validation error on submission.
 */

interface ValidationEffectProps {
  action: GaAction;
}

export default function ValidationEffect({ action }: ValidationEffectProps) {
  const { isValid, submitCount, errors } = useFormikContext<any>();
  useEffect(() => {
    if (!isValid && submitCount > 0) {
      // Track email errors separately
      if ('email' in errors || 'confirmEmail' in errors) {
        const emailLabel = errors.email as string | undefined;
        const confirmEmailLabel = errors.confirmEmail as string | undefined;
        fireGAEvent({
          category: GaCategory.Recruitment,
          action: GaAction.ValidationErrorsApplyEmail,
          label: emailLabel || confirmEmailLabel
        });
      }
      // Track the erroneous fields as a GA event.
      fireGAEvent({
        category: GaCategory.Recruitment,
        action,
        label: Object.keys(errors).join(', ')
      });
    }
  }, [submitCount]);

  return null;
}
